<div
  class="proxy-approve-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="proxy-approve-request-title"
  appFocusTrap
>
  <header class="proxy-approve-modal__header flex align-center justify-between">
    <div class="flex align-center gap-12">
      <span class="proxy-approve-modal__header-icon" aria-hidden="true">
        <app-icon
          name="person_add"
          size="sm"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
      </span>
      <div>
        <h2 id="proxy-approve-request-title" class="proxy-approve-modal__title fs-16 fw-700 m-0">
          Approve Proxy Access
        </h2>
        <p class="fs-12 m-0 proxy-approve-modal__subtitle">
          {{ proxyName() }} → {{ patientName() }}
        </p>
      </div>
    </div>
    <button
      type="button"
      class="proxy-approve-modal__close"
      (click)="cancel()"
      aria-label="Close approve request modal"
    >
      <app-icon
        name="close"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
    </button>
  </header>

  <div class="proxy-approve-modal__body">
    <div class="grant-banner flex align-start gap-12" role="alert" aria-live="assertive">
      <app-icon
        class="grant-banner__icon"
        name="warning"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <p class="fs-12 m-0">
        <strong>This grants access to protected health information.</strong>
        {{ proxyName() }} will be able to view this patient’s records in the portal. Confirm the
        record below is the right patient before approving.
      </p>
    </div>

    <!-- The screen preselects the first search hit, so the record is restated in
         full here — this is the step where a wrong preselection gets caught. -->
    <section class="record-card" aria-labelledby="proxy-approve-record-title">
      <h3 id="proxy-approve-record-title" class="record-card__heading fs-11 fw-600">
        Patient record being linked
      </h3>
      <p class="record-card__name fs-14 fw-600 m-0">{{ patient().displayName }}</p>
      <dl class="record-card__fields">
        @for (field of recordFields(); track field.label) {
        <div class="record-card__field">
          <dt class="fs-11">{{ field.label }}</dt>
          <dd class="fs-12">{{ field.value }}</dd>
        </div>
        }
      </dl>
    </section>

    <p class="proxy-approve-modal__relationship fs-12 m-0">
      Requested as: <strong>{{ relationshipSummary() }}</strong>
    </p>

    @if (approveError()) {
    <p class="approve-error fs-12" role="alert">{{ approveError() }}</p>
    }

    <div class="proxy-approve-modal__actions flex justify-end align-center gap-12">
      <button
        type="button"
        class="secondary-button fw-600 proxy-approve-modal__cancel"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="primary-button fw-600 flex align-center gap-8"
        (click)="submit()"
        [disabled]="isApprovingRequest()"
      >
        <app-icon
          name="check_circle"
          size="xs"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
        <span>{{ isApprovingRequest() ? 'Approving…' : 'Approve Access' }}</span>
      </button>
    </div>
  </div>
</div>
